module.exports = __webpack_public_path__ + "img/active-fourth.2ca3af36.png";